import { action, extendObservable } from "mobx";
import { FETCH_URL } from "../constants/ServerLinks";

class Metrics {
  constructor({ metrics = [] }) {
    extendObservable(this, metrics);
    this.apiUrl = FETCH_URL + "/api/v1/metrics/?country_id=";
  }

  @action
  fetchMetrics = async (countryId) => {
    const response = await fetch(`${this.apiUrl}${countryId.toString()}`);
    const db_metrics = await response.json();
    this.metrics = db_metrics.data;

    // console.group("Metrics:fetchMetrics");
    // console.log(countryId);
    // console.log("data", db_metrics.data);
    // console.groupEnd();
  };
}

export default Metrics;
